export default "/images/fa9e78b0e6bc9641a70e95d5624e833d.png";